const Menu = {
  en: ['TIMELY ELECTRIC', 'Home', 'Production', 'Installation', 'Safety', 'About'],
  cn: ['即实电气', '主页', '产品', '安装', '安全', '关于'],
};
const Home = {
  en: [
    [
      'Powering and Helping your EVEMS Solutions',
      'Expert electricians ensuring safety and efficiency in every project',
      'GET FREE QUOTE',
      'PRODUCT DETAIL',
    ],
    [
      'Our Mission',
      'At Timely Electric, our mission is to provide reliable and efficient electrical services including EVEMS  to our community. ',
      'We are dedicated to ensuring the highest standards of safety and quality in every project we undertake.',
      'More About Us',
    ],
    [
      'One-Stop Service',
      'Free Quotation',
      'Fast Installation',
      'One Year Warranty',
    ],
    'Our Partners'
  ],
  cn: [
    [
      '为您的 EVEMS 解决方案提供动力和帮助',
      '专业电工确保每个项目的安全和高效',
      '免费咨询',
      '产品详情',
    ],
    [
      '我们的使命',
      '即实电气为社区提供可靠高效的电力服务，包括EVEMS系统。',
      '我们致力于确保承接的每个项目都符合最高的安全和质量标准。',
      '更多关于我们',
    ],
    [
      '一站式服务',
      '免费咨询',
      '快速安装',
      '一年保修',
    ],
    '合作伙伴'
  ],
};
const Product = {
  en: [
    'Timely Electric provides various models of EVEMS',
    [
      'No Main Panel Upgrade Required, SAVE UP TO $6000-10000 in panel upgrade',
      'Works with 100-200 AMP panels/services',
      'Eligiable BC Hydro rebate, QAI certified, and Patent Pending',
    ],
    'APPLY BE A DEALER',
    'Get a Free Quote from EVEMS',
    'Send mail',
    'Technical data', 
    'Manual',
    'ORDER',
    'Quantity', 
    'Add to cart'
  ],
  cn: [
    '即实电气提供多种型号的 EVEMS 产品',
    [
      '无需更换主配电箱，节省高达6000-10000美元面板升级费用',
      '适用于100-200安培的配电箱/供电系统',
      'BCHydro 折扣计划清单，获得 QAI 电气认证，专利申请审核中',
    ],
    '申请成为经销商',
    '免费咨询 EVEMS 产品',
    '发送邮件',
    '技术参数', 
    '产品说明', 
    '订单',
    '数量', 
    '加入购物车'
  ]
};
const Install = {
  en: [
    'Please follow the installation wizard carefully', 
    ['Pre-installation check', 'a. Electrical load calculations to confirm not overload the electrical panel;', 'b. need 2 spare slots for a 2-pole breaker.'], 
    ['Installation steps', 'a. Hire quality person to install the EVEMS;', 'b. Turn off man the breaker;', 'c. Following the manual step by step.'], 
    ['Post-installation test', 'a. Make sure correct connections;', 'b. Turn main breaker;', 'c. Test the car charger.'],
    [
      'Troubleshoting',
      [
        'Q: The “EVEMS” line on the LCD screen indicates “OFF”.',
        'A: There is not enough electrical load available to allow to turn the EVEMS “ON”.<br>\
          When the higher load demand electrical devices (for example: Dryer, Stove etc.) disengage there will be sufficient electric load available to allow the engagement.<br>\
          If the EV charging becomes priority, stop using the higher load demand electrical devices for the duration of the EV charger. '
      ],
      'More Q&A'
    ]
  ],
  cn: [
    '请严格根据安装向导操作', 
    ['安装前检查', 'a. 进行电气负荷计算，确认电气面板不会过载；', 'b. 需要 2 个备用插槽用于 2 极断路器。'], 
    ['安装中步骤', 'a. 聘请专业人员安装 EVEMS；', 'b. 自行关闭断路器；', 'c. 按照手册一步一步操作。'], 
    ['安装后测试', 'a. 确保连接正确；', 'b. 打开主断路器；', 'c. 测试车载充电器。'],
    [
      '故障排除',
      [
        '问：“EVEMS”的液晶屏上显示为“关闭”。',
        '答：当前电力负荷不足，无法启动电动汽车能量管理系统（EVEMS）。<br>\
          当高耗电设备（例如：烘干机、电炉等）停止运行时，将有足够的电力负荷可供系统启动。<br>\
          若需优先进行电动汽车充电，请在充电期间暂停使用高耗电设备。'
      ],
      '更多问答'
    ]
  ],
};
const Safety = {
  en: [
    'EVEMS have triple safety guarantees',
    [
      'QAI Certification: Number E11401', 
      'Founded in 1995 by a group of experienced certification and testing experts, QAI is an independent third-party testing, inspection and certification organization which serves the building industry, government and individuals with cost effective solutions through our in-house capabilities / services, and an established world-wide network of qualified affiliates. '
    ], 
    [
      'iPFS Insurance',
      'Imperial PFS Canada provides you with the best payments plans, customized for you and your customers. Experience Canada’s top leader of payments solutions for the insurance industry.'
    ], 
    [
      'Timely Electric Warranty',
      `
      <p>This Warranty Agreement (“Agreement”) is entered into by the Manufacturer or Authorized Distributor (“Company”) and the purchaser (“Customer”) for electrical equipment purchased and used in North America.</p>

      <h2>1. Warranty Coverage</h2>
      <p>The Company warrants that the product is free from defects in materials and workmanship under normal use during the warranty period. This warranty applies only to the original purchaser and is non-transferable.</p>

      <h2>2. Warranty Period</h2>
      <p>For a period of <strong>12 months</strong> from the date of purchase, if the product fails due to defects in materials or workmanship, the Company will repair or replace it at no charge.</p>

      <h2>3. Exclusions & Limitations</h2>
      <ul>
          <li>Damage caused by misuse, abuse, accident, unauthorized repair, or modification is not covered.</li>
          <li>Damage caused by external factors (including but not limited to abnormal voltage, natural disasters) is excluded.</li>
          <li>Consumable parts such as fuses, light bulbs, and batteries are not covered.</li>
      </ul>

      <h2>4. Warranty Claim Process</h2>
      <ol>
          <li>The Customer must provide a valid proof of purchase (invoice or receipt).</li>
          <li>The Customer must contact the Company’s customer service department to obtain a Return Merchandise Authorization (RMA) number.</li>
          <li>The Customer must return the product with the RMA number to the designated service center.</li>
      </ol>

      <h2>5. Governing Law</h2>
      <p>This Agreement shall be governed by the laws of the state or province of purchase and interpreted in accordance with applicable consumer protection laws. This Agreement does not affect any statutory rights that the Customer may have under local laws.</p>

      <p style="margin-top:30px;">This Agreement is effective as of the date of purchase.</p>
      `,
    ]
  ],
  cn: [
    'EVEMS具有三重安全保障',
    [
      'QAI 认证: 认证号 E11401 ',
      'QAI 由一群经验丰富的认证和测试专家于 1995 年创立，是一家独立的第三方测试、检验和认证机构，通过我们的内部能力/服务以及遍布全球的合格分支机构网络，为建筑行业、政府和个人提供具有成本效益的解决方案。'
    ], 
    [
      'iPFS 产品保险',
      'Imperial PFS Canada 为您提供最佳的付款计划，专为您和您的客户量身定制。体验加拿大保险行业付款解决方案的顶级领导者。'
    ], 
    [
      '即实电气产品保修',
      `
      <p>本保修协议（以下简称“协议”）由制造商或授权经销商（以下简称“本公司”）与购买方（以下简称“用户”）订立，适用于在北美地区购买并使用的电气设备。</p>

      <h2>一、保修范围</h2>
      <p>本公司保证在正常使用条件下，所售电气设备在保修期内无材料及工艺上的缺陷。本保修仅适用于原始购买人，并不可转让。</p>

      <h2>二、保修期限</h2>
      <p>自购买之日起 <strong>12 个月</strong> 内，如设备因材料或工艺缺陷而发生故障，本公司将免费维修或更换。</p>

      <h2>三、免责条款</h2>
      <ul>
          <li>因误用、滥用、意外、未经授权的维修或改装造成的损坏不在保修范围内。</li>
          <li>因外部因素（包括但不限于电压异常、自然灾害）造成的损坏不在保修范围内。</li>
          <li>消耗性部件（如保险丝、灯泡、电池）不在保修范围内。</li>
      </ul>

      <h2>四、索赔流程</h2>
      <ol>
          <li>用户需提供有效的购买凭证（发票或收据）。</li>
          <li>用户应联系本公司客服部门获取返修授权（RMA）编号。</li>
          <li>用户需将设备连同RMA编号寄回指定维修中心。</li>
      </ol>

      <h2>五、法律适用</h2>
      <p>本协议受购买地所在州或省的法律管辖，并依据相关消费者保护法律解释。本协议不影响用户根据当地法律享有的其他合法权利。</p>

      <p style="margin-top:30px;">本协议自购买之日起生效。</p>      
      `
    ]
  ],
};
const About = {
  en: [
    [
      'Our Mission',
      'At Timely Electric, our mission is to provide reliable and efficient electrical services including EVEMS  to our community. We are dedicated to ensuring the highest standards of safety and quality in every project we undertake.',
    ],
    [
      "What does the name 'Timely' actually mean?",
      'Doing project at right way on time.'
      // 'Quality you trust, delivered on time.\n We believe that every project is more than just construction, it is a mission that carries our clients’ dreams and trust.\n  “Timely” is not only about punctuality; it represents our commitment to integrity, responsibility, and excellence.',
    ],
    [
      'Meet our Management Team',
      {
        name:'John', 
        desc:[
          'Harry is a 20+ year seasoned traveler having and has seen much of North America via camper vans. He has a passion for designing quality camper van products that are worry-free and let him focus on what really matters: over landing with a purpose.',
          'When Simon isn’t in the shop working with wood, fibreglass, steel or aluminum he’s out hiking, Mountain Biking, Trail Building, Backcountry Skiing, and Paddle Boarding.',
          'Husband and father of two boys he understands the importance of having a well organized camper to make the most of every weekend with the family.'
        ]
      },
      {
        name:'Thomas', 
        desc:[
          'William’s love of travelling began in 2001 on a two month journey across Canada in a camper van thus prompting her to feel that Van’s would always be a part of her family life.',
          'enjoys adventuring in the mountains with her family and their dog Watson and outdoor activities such as Mountain biking, paddle boarding, skiing and enjoying good food together.',
          'When she’s not in the office looking after Backlands valued clients, you can find her looking for remote camping spots to find peace and tranquillity on the weekends.'
        ]
      },
      {
        name:'Logan', 
        desc:[
          'Harry is a 20+ year seasoned traveler having and has seen much of North America via camper vans. He has a passion for designing quality camper van products that are worry-free and let him focus on what really matters: over landing with a purpose.',
          'When Simon isn’t in the shop working with wood, fibreglass, steel or aluminum he’s out hiking, Mountain Biking, Trail Building, Backcountry Skiing, and Paddle Boarding.',
          'Husband and father of two boys he understands the importance of having a well organized camper to make the most of every weekend with the family.'
        ]
      },
    ],
    'Contact us'
  ],
  cn: [
    [
      '我们的使命',
      '即实电气为社区提供可靠高效的电力服务，包括EVEMS系统。我们致力于确保承接的每个项目都符合最高的安全和质量标准。',
    ],
    [
      'Timely 意味着什么？', 
      '按时、按正确的方式完成项目。'
      // '筑品质工程，守准时承诺。\n 我们坚信，每一个工程都不仅仅是一项建造任务，而是承载客户梦想与信任的使命。\n “Timely” 不只是时间的概念，它代表我们对 承诺、责任与卓越 的坚持', 
    ],
    [
      '认识我们的管理团队', 
      {
        name:'徐江泉',
        desc:[
          'HOMAPP.COM只为推荐的房产经纪人提供技术服务，不参与房产经纪人的任何房产交易相关服务，也不对房产经纪人的任何房产交易过程和结果负责。',
          'HOMAPP.COM只为推荐的房产经纪人提供技术服务，不参与房产经纪人的任何房产交易相关服务，也不对房产经纪人的任何房产交易过程和结果负责。',
          'HOMAPP.COM只为推荐的房产经纪人提供技术服务，不参与房产经纪人的任何房产交易相关服务，也不对房产经纪人的任何房产交易过程和结果负责。'
        ]
      },
      {
        name:'托马斯',
        desc:[
          'HOMAPP.COM只为推荐的房产经纪人提供技术服务，不参与房产经纪人的任何房产交易相关服务，也不对房产经纪人的任何房产交易过程和结果负责。',
          'HOMAPP.COM只为推荐的房产经纪人提供技术服务，不参与房产经纪人的任何房产交易相关服务，也不对房产经纪人的任何房产交易过程和结果负责。',
          'HOMAPP.COM只为推荐的房产经纪人提供技术服务，不参与房产经纪人的任何房产交易相关服务，也不对房产经纪人的任何房产交易过程和结果负责。'
        ]
      },
      {
        name:'洛根',
        desc:[
          'HOMAPP.COM只为推荐的房产经纪人提供技术服务，不参与房产经纪人的任何房产交易相关服务，也不对房产经纪人的任何房产交易过程和结果负责。',
          'HOMAPP.COM只为推荐的房产经纪人提供技术服务，不参与房产经纪人的任何房产交易相关服务，也不对房产经纪人的任何房产交易过程和结果负责。',
          'HOMAPP.COM只为推荐的房产经纪人提供技术服务，不参与房产经纪人的任何房产交易相关服务，也不对房产经纪人的任何房产交易过程和结果负责。'
        ]
      }
    ],
    '联系我们'
  ],
};
const Claim = {
  en: [
    'Timely Electric \nDiv. of Timely Construction Ltd.', 
    'Vancouver, BC, Canada',
    'Copyright',
    'Payment by',
    'Terms of Service',
    'Privacy Policy'
  ],
  cn: [
    '即实电气-天时建筑有限公司',
    '加拿大哥伦比亚省温哥华',
    '版权所有',
    '支付合作',
    '服务条款',
    '隐私政策' 
  ],
};


export const Lang = {
  Menu,
  Home,
  Product,
  Install,
  Safety,
  About,
  Claim,
}